import { cn, Button, NotificationBadge, Typography } from '@up-riac/bespoke-ui';
import React from 'react';

type HeaderIconButtonProps = {
  IconComponent: React.ElementType,
  label: string,
  notificationCount?: number,
  className?: string,
  children?: React.ReactNode,
  hideLabel?: boolean,
  id?: string,
} & ({
  to: string,
} | ({
  onPress: () => void,
}))

export const HeaderIconButton = React.forwardRef<HTMLButtonElement, HeaderIconButtonProps>((props, ref) => {
  const { IconComponent, label, notificationCount = 0, className, hideLabel, children, ...buttonProps } = props;

  return (
    <Button
      ref={ref}
      unstyled
      {...buttonProps}
      id={props.id}
      className={cn('p-2 rounded-full focus:rounded-full hover:bg-neutral-200 active:bg-neutral-300 text-text-contrast size-10 relative group', className)}
      aria-label={hideLabel ? label : undefined}
    >
      <>
        <IconComponent className={'size-6'} />

        {notificationCount > 0 && (
          <NotificationBadge className={'absolute right-1.5 top-2'} whiteBorder />
        ) || ''}

        {!hideLabel
          && <Typography size='xs' weight='bold' className={'pointer-events-none absolute bottom-1 left-1/2 -translate-x-1/2 w-max translate-y-full opacity-0 group-hover:opacity-100 transition-all'}>
            {label}
          </Typography>
        }
        {children}
      </>
    </Button>
  );
});

HeaderIconButton.displayName = 'HeaderIconButton';
